import { Button } from '../ui/button';
import { X, Hash, AtSign, MapPin } from 'lucide-react';

const STICKERS = [
  { type: 'hashtag', text: '#DMVSoundstage', icon: Hash, bgColor: 'rgba(139,92,246,0.8)' },
  { type: 'hashtag', text: '#NewMusic', icon: Hash, bgColor: 'rgba(139,92,246,0.8)' },
  { type: 'hashtag', text: '#DMV', icon: Hash, bgColor: 'rgba(139,92,246,0.8)' },
  { type: 'hashtag', text: '#NowPlaying', icon: Hash, bgColor: 'rgba(59,130,246,0.8)' },
  { type: 'hashtag', text: '#LinkInBio', icon: Hash, bgColor: 'rgba(236,72,153,0.8)' },
  { type: 'mention', text: '@username', icon: AtSign, bgColor: 'rgba(34,197,94,0.8)' },
  { type: 'location', text: 'Washington DC', icon: MapPin, bgColor: 'rgba(249,115,22,0.8)' },
  { type: 'location', text: 'Baltimore MD', icon: MapPin, bgColor: 'rgba(249,115,22,0.8)' },
  { type: 'location', text: 'DMV Area', icon: MapPin, bgColor: 'rgba(249,115,22,0.8)' },
  { type: 'custom', text: 'NEW DROP', bgColor: 'rgba(239,68,68,0.9)' },
  { type: 'custom', text: 'LISTEN NOW', bgColor: 'rgba(139,92,246,0.9)' },
  { type: 'custom', text: 'OUT NOW', bgColor: 'rgba(34,197,94,0.9)' },
  { type: 'custom', text: 'LINK IN BIO', bgColor: 'rgba(59,130,246,0.9)' },
  { type: 'custom', text: 'FOLLOW ME', bgColor: 'rgba(236,72,153,0.9)' },
  { type: 'custom', text: 'SWIPE UP', bgColor: 'rgba(249,115,22,0.9)' },
];

export default function StickerPanel({ onAdd, onClose }) {
  return (
    <div className="bg-card border-t border-border p-3 max-h-56 overflow-y-auto" data-testid="sticker-panel">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium">Stickers</span>
        <Button variant="ghost" size="icon" onClick={onClose}><X className="w-4 h-4" /></Button>
      </div>

      <div className="grid grid-cols-3 gap-2">
        {STICKERS.map((s, i) => (
          <button key={i} onClick={() => onAdd(s)}
            className="py-2.5 px-2 rounded-lg text-xs font-semibold text-white text-center transition-all hover:scale-105 active:scale-95 flex items-center justify-center gap-1"
            style={{ backgroundColor: s.bgColor }}
            data-testid={`sticker-${i}`}>
            {s.icon && <s.icon className="w-3 h-3" />}
            {s.text}
          </button>
        ))}
      </div>
    </div>
  );
}
